import React from 'react'
import { becomeHomestayGif } from "../../images/";
import styled from 'styled-components'

const GifContainer = styled.img `
  width: 100%;
  height: auto;
`

const WorkWithUsFAQAccordion = () => {
  return (
    <div id="accordion">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            What's the application process?
            </button>
          </h5>
        </div>

        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
          <GifContainer src={becomeHomestayGif}/>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            What locations are needed?
            </button>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
        <div class="card-body">
          We welcome homestay families in all locations, as our students study throughout the UK.
We currently have a high demand for homestays in these areas:

          <ul class="card-body">
            <li>Bath</li>
            <li>Blackpool</li>
            <li>Durham</li>
            <li>Edinburgh</li>
            <li>Lancashire</li>
            <li>Leeds</li>
            <li>London and the South East</li>
            <li>Oxford</li>
            <li>Manchester</li>
            <li>North Yorkshire</li>
            <li>Shropshire</li>
            <li>The Lake District</li>
            <li>York</li>
          </ul>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingFour">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
            What are the benefits of hosting students?
            </button>
          </h5>
        </div>
        <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
          <div class="card-body">
          Choosing to become a homestay is a rewarding and fulfilling experience. It’s an opportunity to share culture, language and knowledge, provide care and support and build lasting friendships. Students and their families have stayed in regular contact with homestays long after their studies have finished. Some Homestays have traveled thousands of miles to attend weddings.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingFive">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
            How much allowance will I get?
            </button>
          </h5>
        </div>
        <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordion">
          <div class="card-body">
          Homestays receive a daily allowance to cover food and accommodation expenses. The allowance varies depending on the type of student you host (e.g. boarding school/language school/part of a group). To find out what the daily allowance is for the types of students suitable for you, please contact <a href={"mailto:office@studylinks.co.uk"}>office@studylinks.co.uk</a>.
          To find out more about the government’s ‘Rent a Room’ scheme, <a href={"https://www.gov.uk/rent-room-in-your-home/the-rent-a-room-scheme"}>click here</a>.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingSix">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
            What is the difference between long and short stay homestay?
            </button>
          </h5>
        </div>
        <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordion">
          <div class="card-body">
            Short term homestay students stay from one or two days up to a month. They are usually students who are 18 or younger, who need a homestay during short school holidays and exeat weekends. Short term students will generally be at home all day most days and will need breakfast, lunch and dinner. They generally go home for long holidays such as Christmas and summer.
            <br/>
            <br/>
            Long term homestay students generally stay from 6 weeks up to one year or longer. Long term students are usually 14 and above. Long term students need homestays for different reasons. Some students come to the UK for an English course which can last 6 weeks to 12 months or more. Others are day students at schools in the UK so will be at school during the week. Those studying at college or university will vary their working week pattern between lessons and lectures, or studying at home. During the week, long term students are usually out most of the day so only require breakfast and dinner.
            <br/>
            <br/>
The allowance paid for being a homestay is relative to the level of care required. Because short term students require more care, the allowance is more generous than for a long term student.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingSeven">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
            How do I apply to be a Study Links homestay?
            </button>
          </h5>
        </div>
        <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordion">
          <div class="card-body">
            <div>
            To apply to become one of our homestays Study Links homestay, <a href="/homestay_application" target="_blank">click here</a>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingEight">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
            What must I provide?
            </button>
          </h5>
        </div>
        <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordion">
          <div class="card-body">
            <div>
            Homestays must provide a bed, a space to study and up to three meals per day, depending on the type of students you will have. Students should keep their own room clean and tidy, but there is an expectation for you to provide clean towels and bed linen, as well as keeping your house clean and tidy.
            </div>
          </div>
        </div>
      </div>
      <div class = "card">
        <div class="card-header" id="headingNine">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
            How long should I expect to host a student for?
            </button>
          </h5>
        </div>
        <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordion">
            <div class="card-body">
            This depends. Long term students can stay from 6 weeks up to one year or more, whereas short term students only stay from a few days up to a few weeks. For more information <a href="/homestay_application" target="_blank">click here</a>.
            </div>
          </div>
      </div>
      
    </div>
  )
}

export default WorkWithUsFAQAccordion